import { render } from "./ResourcesSection.vue?vue&type=template&id=73c887fa"
import script from "./ResourcesSection.vue?vue&type=script&lang=js"
export * from "./ResourcesSection.vue?vue&type=script&lang=js"

import "./ResourcesSection.vue?vue&type=style&index=0&id=73c887fa&lang=scss&rel=scss%2Fstylesheet"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__